import './App.css';
import { Amplify } from 'aws-amplify';
import config_json from './exports';
import {useEffect} from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import {Outlet} from 'react-router-dom';

//aws configure credentials
//AKIAYFQF3INRTKYZTJRO
//RKzgQSJZX18hGD4k9S3Yz3KefmXiXZOf6EwW3w9E

Amplify.configure(config_json);




export default function App() {


  return (
    <>
     <Header/>
     <Outlet/>
     <Footer/>         
    </>

  );
}

 



